import $ from "jquery";
import AOS from "aos";

import Calendar from "js-year-calendar";
import "js-year-calendar/dist/js-year-calendar.css";
import tippy from "tippy.js";
import "lightgallery.js/dist/js/lightgallery.js";
/* import Pagination from "paginationjs";
import "paginationjs/dist/pagination.js"; */

import { Menu } from "./components/Menu";
import Swiper from "swiper";

import "bootstrap/js/dist/util";
import "bootstrap/js/dist/modal";
import "bootstrap/js/src/collapse";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/tab";

import "masonry-layout/dist/masonry.pkgd";

import "./components/Swiper";
import "./components/Menu";
import "./components/Masonry";
import "./components/Accordion";
import "./components/Calendar";
import "./components/MonthCalendar";
import "./components/Tickets";
import "./components/MapTp";
import "./components/CheckboxCart";

AOS.init({
  duration: 900,
});

Menu(".js-menu");

lightGallery(document.getElementById("animated-thumbnials"), {
  thumbnail: true,
  animateThumb: false,
  showThumbByDefault: false,
});

$("#videoOverlay").click(function(e) {
  $("#videoOverlay").fadeOut("slow");
  $("#homepageVideo").trigger("play");
});

$(window).on("load", function() {
  $("#sectionLoader").animate(
    {
      opacity: 0,
    },
    1000,
    function() {
      $("#sectionLoader").addClass("sectionLoaderHide");
    }
  );
});
